<template>
  <div class="recyle-page" @click="preview">
    <img
      class="recyle-img"
      :src="imgSrc"
      alt="回收内容"
      loading="lazy"
      draggable="false"
    />
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  name: "RecylePage",
  data() {
    return {
      imgSrc: require("@/assets/goldProductDetail/recyleContent.png"),
    };
  },
  methods: {
    preview() {
      ImagePreview({
        images: [this.imgSrc],
        closeOnPopstate: true,
        showIndex: false,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.recyle-page {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0; // 需要留白可自行调整
  overflow-x: hidden;
}
.recyle-img {
  width: 100%;
  // height: auto;
  object-fit: contain;
  display: block;
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
</style>
